(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/init.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/init.js');
'use strict';

const tickets = svs.tickets;
const PLAY_PATH = svs.tickets.play.utils.constants.PLAY_PATH;
const _svs$app$ReactRouter = svs.app.ReactRouter,
  PlayerRouter = _svs$app$ReactRouter.PlayerRouter,
  Route = _svs$app$ReactRouter.Route,
  matchPath = _svs$app$ReactRouter.matchPath;
const Wrapper = tickets.next.containers.Wrapper;
const NEXT_ROUTES = [{
  path: ['/', '/lobby', '/mer'],
  component: () => {
    var _tickets$next$areas$l;
    return (_tickets$next$areas$l = tickets.next.areas.lobby) === null || _tickets$next$areas$l === void 0 ? void 0 : _tickets$next$areas$l.Lobby;
  }
}, {
  path: '/valja/:ticketType',
  component: () => {
    var _tickets$next$areas$p;
    return (_tickets$next$areas$p = tickets.next.areas.pick) === null || _tickets$next$areas$p === void 0 ? void 0 : _tickets$next$areas$p.Pick;
  }
}, {
  path: '/mina-spel/:wagerId',
  component: () => {
    var _tickets$next$areas$m;
    return (_tickets$next$areas$m = tickets.next.areas.mybets) === null || _tickets$next$areas$m === void 0 ? void 0 : _tickets$next$areas$m.MyBets;
  }
}, {
  path: PLAY_PATH,
  component: () => {
    var _tickets$next$areas$p2;
    return (_tickets$next$areas$p2 = tickets.next.areas.play) === null || _tickets$next$areas$p2 === void 0 ? void 0 : _tickets$next$areas$p2.Play;
  }
}];
const matchNextRoute = path => {
  for (const routeConfig of NEXT_ROUTES) {
    const routeMatch = matchPath(path, {
      path: routeConfig.path,
      exact: true,
      strict: false
    });
    if (routeMatch) {
      return {
        routeConfig,
        routeMatch
      };
    }
  }
  return null;
};
tickets.next.matchesRoute = path => Boolean(matchNextRoute(path));
tickets.next.init = () => {
  var _routeConfig$componen;
  const logger = new svs.core.log.Logger('module:tickets');
  const baseUrl = svs.core.data.baseUrl;
  const currentPath = window.location.pathname.startsWith(baseUrl) ? window.location.pathname.slice(baseUrl.length) || '/' : window.location.pathname;
  const container = document.getElementById('reactContainer');
  const matchedRoute = matchNextRoute(currentPath);
  if (!container) {
    logger.warn('initNext could not find #reactContainer');
    return;
  }
  if (!matchedRoute) {
    logger.warn("initNext has no component configured for path ".concat(currentPath));
    return;
  }
  const routeConfig = matchedRoute.routeConfig;
  const NextPage = (_routeConfig$componen = routeConfig.component) === null || _routeConfig$componen === void 0 ? void 0 : _routeConfig$componen.call(routeConfig);
  if (typeof NextPage !== 'function') {
    logger.warn("initNext missing component for path ".concat(currentPath));
    return;
  }
  const router = React.createElement(PlayerRouter, {
    basename: baseUrl,
    withRouter: true
  }, NEXT_ROUTES.map(nextRoute => {
    const renderPage = routeProps => {
      var _nextRoute$component;
      const PageComponent = (_nextRoute$component = nextRoute.component) === null || _nextRoute$component === void 0 ? void 0 : _nextRoute$component.call(nextRoute);
      if (typeof PageComponent !== 'function') {
        logger.warn("initNext missing component during route render for path ".concat(nextRoute.path));
        return null;
      }
      const imagePosition = 'high';
      return React.createElement(Wrapper, {
        imagePosition: imagePosition
      }, React.createElement(PageComponent, {
        history: routeProps.history,
        location: routeProps.location,
        match: routeProps.match,
        staticContext: routeProps.staticContext
      }));
    };
    return React.createElement(Route, {
      component: renderPage,
      exact: true,
      key: nextRoute.path,
      path: nextRoute.path
    });
  }));
  ReactDOM.render(router, container);
};

 })(window);